module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.numberAccor), function(elem, index) {
    return _c('div', {
      staticClass: "accordion",
      attrs: {
        "xs12": "",
        "xs12": ""
      }
    }, [_c('button', {
      staticClass: "accordion-bot",
      on: {
        "click": function($event) {
          _vm.accorClick(index)
        }
      }
    }, [_vm._t('title-' + index), _vm._v(" "), _c('v-icon', {
      attrs: {
        "aria-hidden": "true"
      }
    }, [_vm._v("fas " + _vm._s(_vm.currentCont === (index + 1) ? 'fa-angle-up' : 'fa-angle-down'))])], 2), _vm._v(" "), _c('div', {
      staticClass: "accordion-cont",
      class: _vm.currentCont === (index + 1) ? 'active' : ''
    }, [(_vm.currentCont === (index + 1)) ? _vm._t('cont-' + index) : _vm._e()], 2)])
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17ceccf6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/accordion.vue
// module id = 948
// module chunks = 1